import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Constant import.
 */
import { NUMBERS } from '../../../constants/app.constants';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

/**
 * This component is used to show the suggestion list of forword flows.
 */
@Component({
  selector: 'app-forword-flows-suggestion-card',
  templateUrl: './forword-flows-suggestion-card.component.html',
  styleUrls: ['./forword-flows-suggestion-card.component.scss']
})
export class ForwordFlowsSuggestionCardComponent {

  /**
   * Data binding , Receving data from parent.
   */
  @Input() ffData;
  @Output() cardClickAction = new EventEmitter();

  /**
   * used to hold the constant value.
   */
  public numbers = NUMBERS;
   constructor( public mls : NewLanguageService){}
}
